<template>
  <mescroll-vue
    ref="mescroll"
    :down="mescrollDown"
    :up="mescrollUp"
    @init="mescrollInit"
  >
    <tabbar></tabbar>

    <div class="activity-list">
      <div class="type">
        <el-select
          v-model="selectType"
          placeholder="请选择品牌"
          @change="handleChange"
        >
          <el-option
            v-for="(item, index) in itemLists"
            :key="item.dictCode"
            :label="item.dictName"
            :value="item.dictCode"
          >
          </el-option>
        </el-select>
      </div>
      <el-tabs v-model="activeName" type="card" @tab-click="changeActiveName">
        <el-tab-pane label="往期活动" name="end">
          <div class="activity" v-for="(item, index) in dataList">
            <div class="homeimg">
              <img :src="getImage(item.image)" width="100%" height="100%" />
            </div>
            <div class="title">
              <p>{{ item.activityName }}</p>
              <el-button round class="fr over" @click="addActive(index, item)"
                >结束</el-button
              >
            </div>
          </div>
          <div class="noData" v-if="!dataList.length">暂无数据</div>
        </el-tab-pane>
        <el-tab-pane label="正在进行" name="going">
          <div class="activity" v-for="(item, index) in dataList"  @click="addActive(index, item)">
            <div class="homeimg">
              <img :src="getImage(item.image)" width="100%" height="100%" />
            </div>
            <div class="title">
              <p>{{ item.activityName }}</p>
              <el-button round class="fr"
                >报名</el-button
              >
            </div>
          </div>
          <div class="noData" v-if="!dataList.length">暂无数据</div>
        </el-tab-pane>
        <!-- <el-tab-pane label="敬请期待" name="noStart">
          <div class="activity" v-for="(item, index) in dataList" @click="addActive(index, item)">
            <div class="homeimg">
              <img :src="getImage(item.image)" width="100%" height="100%" />
            </div>
            <div class="title">
              <p>{{ item.activityName }}</p>
              <el-button round class="fr" 
                >报名</el-button
              >
            </div>
          </div>
          <div class="noData" v-if="!dataList.length">暂无数据</div>
        </el-tab-pane> -->
      </el-tabs>
      <float v-show="isToken"></float>
    </div>
  </mescroll-vue>
</template>
<script>
import MescrollVue from "mescroll.js/mescroll.vue";

export default {
  name: "activitylist",
  components: {
    MescrollVue // 注册mescroll组件
  },
  props: ["activityType", "exhibitionType"],

  data() {
    return {
      isActive: "",
      activeName: "end",
      //分页功能
      totalPage: [],
      // 每页显示数量
      pageSize: 3,
      // 共几页
      pageNum: 0,
      // 当前显示的数据
      dataList: [],
      // 默认当前显示第一页
      currentPage: 1,
      isToken: true, //url中是否有token
      mescroll: null, // mescroll实例对象
      mescrollDown: {}, //下拉刷新的配置. (如果下拉刷新和上拉加载处理的逻辑是一样的,则mescrollDown可不用写了)
      mescrollUp: {
        // 上拉加载的配置.
        callback: this.upCallback, // 上拉回调,此处简写; 相当于 callback: function(page, mescroll) { }
        //以下是一些常用的配置,当然不写也可以的.
        page: {
          num: 0, //当前页 默认0,回调之前会加1; 即callback(page)会从1开始
          size: 3 //每页数据条数,默认10
        },
        isBounce: true,
        htmlLoading: '<p class="upwarp-tip">加载中..</p>',
        // 监听滑动
        onScroll: function(mescroll, y, isUp) {
          var navWarp = document.getElementsByClassName("el-tabs__header")[0];
          var content = document.getElementsByClassName("el-tabs__content")[0];
          if (mescroll.os.ios) {
            if (y >= navWarp.offsetTop && navWarp.offsetTop > 0) {
              navWarp.classList.add("nav-sticky");
              content.classList.add("content-margin");
            } else if (y <= 150) {
              navWarp.classList.remove("nav-sticky");
              content.classList.remove("content-margin");
            }
          } else {
            if (y >= navWarp.offsetTop && navWarp.offsetTop > 0) {
              navWarp.classList.add("nav-fixed");
              content.classList.add("content-margin");
            } else if (y <= 150) {
              navWarp.classList.remove("nav-fixed");
              content.classList.remove("content-margin");
            }
          }
        }
      },
      selectType: '',
      itemLists: []
    };
  },
  mounted() {
    this.$nextTick(() => {
      // this.getQueryStringRegExp("token");
      // this.getQueryStringRegExp("museumCode");
      //如果获取到小程序传来的token
      if (this.$store.state.token) {
        this.isToken = false;
      } else {
        this.isToken = true;
      }
      this.getBrandList(this.$store.state.museumCode)
      // this.getitemList();
    });
    document.body.style.backgroundColor = "#fff";
    document.getElementsByClassName("tab-bar")[0].parentElement.style.width =
      "100vw";
    this.activeName = this.getQueryStringRegExp('type') || 'going'
  },
  methods: {
    changeActiveName(val) {
      this.$router.replace(`/activity?type=${this.activeName}&museumCode=${this.$store.state.museumCode}`)
    },
    getQueryStringRegExp: function getQueryStringRegExp(name) {
      var reg = new RegExp("(^|\\?|&)" + name + "=([^&]*)(\\s|&|$)", "i");
      if (reg.test(location.href))
        return unescape(RegExp.$2.replace(/\+/g, " "));
      return "";
    },
    getImage(val) {
      // alert(val)
      let imgArr = val.split(";");
      // alert(imgArr[0])
      return window.SITE_CONFIG.fileBaseApi + imgArr[0];
    },
    addActive(index, item) {
      // this.isActive = index;
      // console.log(this.isActive);
      if (item.link_path) return location.href = item.link_path
      this.$router.push({
        path: `/things/${item.id}`
      });
    },

    handleChange(val) {
      this.mescroll.resetUpScroll();
      this.getitemList(1)
    },

    getBrandList(code) {
      let _this = this
      this.$axios
        .get(
          window.SITE_CONFIG.baseUrl +
            `/api/admin/front/dict/parent-museum?museumCode=${code}&parentCode=activityType`
        )
        .then(function (res) {
          _this.itemLists = res.data.data
          res.data.data.unshift({
            dictCode: '',
            dictName: '全部'
          })
          // _this.typename = _this.itemLists[0].dictName
          _this.getitemList()
        })
    },

    getitemList(page) {
      let currentPage = page || this.currentPage
      this.$axios
        .get(
          window.SITE_CONFIG.baseUrl +
            "/api/activity/web/activity?page=" +
            this.currentPage +
            "&limit=" +
            this.pageSize +
            "&activityType=" +
            this.selectType +
            "&type=" +
            encodeURI(this.activeName) +
            "&museumCode=" +
            this.$store.state.museumCode,
          {}
        )
        .then(response => {
          var result = response.data;
          this.dataList = response.data.data.rows;
          this.pageNum = response.data.data.total;
        });
    },
    mescrollInit(mescroll) {
      this.mescroll = mescroll; // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
    },
    // 上拉回调 page = {num:1, size:10}; num:当前页 ,默认从1开始; size:每页数据条数,默认10
    upCallback(page, mescroll) {
      console.log(page, 111);
      // 联网请求
      this.$axios
        .get(
          window.SITE_CONFIG.baseUrl +
            "/api/activity/web/activity?page=" +
            page.num +
            "&limit=" +
            page.size +
            "&activityType=" +
            this.selectType +
            "&type=" +
            encodeURI(this.activeName) +
            "&museumCode=" +
            this.$store.state.museumCode,
          {}
        )
        .then(response => {
          // 请求的列表数据
          let arr = response.data.data.rows;
          // 如果是第一页需手动置空列表
          if (page.num === 1) this.dataList = [];
          // 把请求到的数据添加到列表
          this.dataList = this.dataList.concat(arr);
          // 数据渲染成功后,隐藏下拉刷新的状态
          this.$nextTick(() => {
            mescroll.endSuccess(arr.length);
          });
        })
        .catch(function(e) {
          // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
          mescroll.endErr();
        });
    }
  },
  watch: {
    activeName() {
      this.mescroll.resetUpScroll();
      // this.dataList = [];
      this.getitemList(1);
      // this.mescroll.resetUpScroll();
      // this.mescroll.scrollTo(0, 0);
    }
  }
};
</script>
<style lang="scss" scoped>
.mescroll {
  position: fixed;
  top: 0;
  bottom: 0;
  overflow-y: scroll;
  z-index: 2;
  // overflow-y: overlay;
}
.noData{
  font-size: 34px;
  text-align: center;
  margin-top: 50px;
}
</style>
<style type="text/css">
  /*场馆下拉框*/
.el-select {
  width: 100% !important;
  /* margin: 0 auto; */
  margin-top: 21px;
  height: 80px;
}

.type {
  width: 100%;
  margin: 0 auto;
}

.type .el-input.el-input--suffix {
  /* background-color: #f2f2f2; */
  border-radius: 5px;
  border: solid 1px #ffffff;
  height: 100%;
}

.el-select-dropdown__item{
  height: 0.8rem;
  line-height: 0.8rem;
  font-size: 0.4rem;
}

/*.el-input{
  h
}*/

.type input.el-input__inner {
  background-color: #f2f2f2;
  border-radius: 5px;
  border: solid 1px #ffffff;
  font-size: 0.4rem;
  font-weight: normal;
  font-stretch: normal;
  /*line-height: 33px;*/
  height: 100%;
  width: 100%;
  letter-spacing: 3px;
  color: #333333;
  opacity: 0.8;
  margin: 0;
}
.type .el-select .el-input.is-focus .el-input__inner,
.el-select .el-input__inner:focus {
  border: none;
}
.type .el-select-dropdown__item.selected {
  color: #b28b16;
}
.el-popper[x-placement^=bottom] .popper__arrow{
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/activityList/activitylist.vue